import { pageConstants } from "../constants/page.constants";

/**
 * Checks if the given pathname is a public page.
 * @param {string} pathname - The current URL pathname.
 * @returns {boolean} True if the page is public, false otherwise.
 */
export default function isPublicPage(pathname) {
    const publicPages = pageConstants.public_pages || [];
    
    return publicPages.includes(pathname);
}